import { render, staticRenderFns } from "./Tranferrencia.vue?vue&type=template&id=094b5e1a"
import script from "./Tranferrencia.vue?vue&type=script&lang=js"
export * from "./Tranferrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports